module.exports = "img/upload-big.ade34b1.svg";